import React from "react";

export default function LogoMarquee() {
  const brands = [
    { name: "Seismic", logo: "/logos/seismic.webp", role: "US Enterprise B2B SaaS" },
    { name: "MyOperator", logo: "/logos/myoperator.webp", role: "India B2B SaaS Brand" },
    { name: "Heyo Phone", logo: "/logos/heyo.webp", role: "SMB B2B App (India)" },
    { name: "Work Hours", logo: "/logos/workhours.webp", role: "E-Learning Platform" },
    { name: "Xpedient Digital", logo: "/logos/xpedient.webp", role: "Digital Media (US Healthcare)" },
    { name: "Boxfinity", logo: "/logos/boxfinity.webp", role: "Digital Marketing (UK Finance)" },
    { name: "Brandpier", logo: "/logos/boomer.webp", role: "Global B2B App Platform" },
  ];

  // Duplicate list to create a seamless infinite loop
  const marqueeList = [...brands, ...brands, ...brands];

  return (
    <section className="py-12 bg-[#070a12] border-y border-white/[0.08] overflow-hidden relative">
      {/* Left/Right Vignette gradients for seamless fade */}
      <div className="absolute top-0 bottom-0 left-0 w-24 sm:w-36 bg-gradient-to-r from-[#070a12] to-transparent z-10 pointer-events-none" />
      <div className="absolute top-0 bottom-0 right-0 w-24 sm:w-36 bg-gradient-to-l from-[#070a12] to-transparent z-10 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 text-center">
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-white/50 font-semibold">
          Proven Impact Across High-Growth B2B SaaS & Digital Enterprises
        </p>
      </div>

      <div className="flex overflow-hidden select-none">
        <div className="animate-marquee-left flex items-center gap-8 sm:gap-12 py-2">
          {marqueeList.map((brand, index) => (
            <div 
              key={`${brand.name}-${index}`}
              className="flex items-center gap-3 px-5 py-3 rounded-xl bg-white/[0.03] border border-white/[0.06] hover:border-[#6366f1]/50 hover:bg-[#4f46e5]/10 transition-all duration-200 group flex-shrink-0 cursor-default"
            >
              <div className="w-8 h-8 rounded-lg bg-white/[0.08] flex items-center justify-center p-1 overflow-hidden group-hover:scale-105 transition-transform">
                <img 
                  src={brand.logo} 
                  alt={brand.name} 
                  loading="lazy"
                  decoding="async"
                  className="max-w-full max-h-full object-contain filter brightness-90 contrast-125 group-hover:brightness-100"
                  onError={(e) => {
                    // text fallback if logo fails
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xs sm:text-sm font-heading font-bold text-white/80 group-hover:text-white transition-colors">
                  {brand.name}
                </span>
                <span className="text-[10px] font-mono text-white/40 group-hover:text-[#38bdf8] transition-colors font-medium">
                  {brand.role}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
